/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks'
import { compose } from '@wordpress/compose'
import { pluginAssetsURL } from 'cartzillagb'
import {
	RichText 
} from '@wordpress/block-editor'

/**
 * Internal dependencies
 */
import { name } from './index'
import { range } from '~cartzillagb/util'

/**
 * External dependencies
 */
import {
	ButtonEditHelper
} from '~cartzillagb/components'
import classnames from 'classnames'

const save = props => {
	const {
		className,
		attributes
	} = props 

	const {
		blockId,
		limit,
		enableButton,
		autoplay
	} = attributes

	const mainClasses = classnames( [
		className,
	], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

	const content = range( 1, limit + 1 ).map( i => {

		const Pretitle = attributes[ `pretitle${ i }` ]
		const Title = attributes[ `title${ i }` ]
		const subTitle = attributes[ `subtitle${ i }` ]
		const MediaURL = attributes[ `mediaURL${ i }` ]
		const bgColor = attributes[ `bgcolor${ i }` ]
		const bgcustomColor = attributes[ `bgcustomcolor${ i }` ]
		const enablepreTitle = attributes[ `enablepreTitle${ i }` ]
		const enableTitle = attributes[ `enableTitle${ i }` ]
		const enablesubTitle = attributes[ `enablesubTitle${ i }` ]

		let defaultPretitle = ''
		let defaultTitle = ''
		let defaultSubtitle = ''
		let defaultImg = ''
		let defaultbgColor = ''

		if ( i % 5 === 1 ) {
			defaultPretitle = 'Has just arrived!'
			defaultTitle = 'Huge Summer Collection'
			defaultSubtitle = 'Swimwear, Tops, Shorts, Sunglasses & much more...'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img1.jpg`
			defaultbgColor = 'rgb(58, 175, 210)'
		}
		if ( i % 5 === 2 ) {
			defaultPretitle = 'Hurry up! Limited time offer.'
			defaultTitle = 'Women Sportswear Sale'
			defaultSubtitle = 'Sneakers, Keds, Sweatshirts, Hoodies & much more...'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img2.jpg`
			defaultbgColor = 'rgb(245, 177, 176)'
		}
		if ( i % 5 === 3 ) {
			defaultPretitle = 'Complete your look with'
			defaultTitle = 'New Mens Accessories'
			defaultSubtitle = 'Sneakers, Keds, Sweatshirts, Hoodies & much more...'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img3.jpg`
			defaultbgColor = 'rgb(235, 161, 112)'
		}
		if ( i % 5 === 4 ) {
			defaultPretitle = 'Has just arrived!'
			defaultTitle = 'Huge Summer Collection'
			defaultSubtitle = 'Swimwear, Tops, Shorts, Sunglasses & much more...'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img1-1.jpg`
			defaultbgColor = 'rgb(58, 175, 210)'
		}
		if ( i % 5 === 0 ) {
			defaultPretitle = 'Hurry up! Limited time offer.'
			defaultTitle = 'Women Sportswear Sale'
			defaultSubtitle = 'Sneakers, Keds, Sweatshirts, Hoodies & much more...'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img2-1.jpg`
			defaultbgColor = 'rgb(245, 177, 176)'
		}

		const bgstyle = { backgroundColor: bgcustomColor !== undefined ? bgcustomColor : defaultbgColor }

		const pretitleComp = enablepreTitle && (
			<RichText.Content
				tagName="h2"
				value={ Pretitle || defaultPretitle }
				className={ `font-weight-light pb-1 text-light ${ attributes[ `pretitleAnimation${ i }` ] } ${ attributes[ `pretitleDelay${ i }` ] }` }
			/>
		)

		const titleComp = enableTitle && (
			<RichText.Content
				tagName="h1"
				className={ `display-4 ${ attributes[ `titleAnimation${ i }` ] } ${ attributes[ `titleDelay${ i }` ] } text-light` } 
				value={ Title || defaultTitle }
			/>
		)

		const subtitleComp = enablesubTitle &&  (
			<RichText.Content
				tagName="p"
				value={ subTitle || defaultSubtitle }
				className={ `font-size-lg pb-3 text-light ${ attributes[ `subtitleAnimation${ i }` ] } ${ attributes[ `subtitleDelay${ i }` ] }` }
			/>
		)

		const buttonComp = enableButton &&(
			<ButtonEditHelper.Content
				attrNameTemplate={ `button${ i }%s"` }
				blockAttributes={ props.attributes }
			/>
		)

		const output = (
			<div className={ `slide-wrapper` } key={ i } >
				<div className={ `px-lg-5 bg-color ${ bgColor }` } style={ bgstyle }>
					<div className="d-lg-flex justify-content-between align-items-center pl-lg-4">
						<img className="d-block order-lg-2 mr-lg-n5 flex-shrink-0" src={ MediaURL !== undefined ? MediaURL : defaultImg } alt="Summer Collection" />
						<div className="slider-content position-relative mx-auto mr-lg-n5 py-5 px-4 mb-lg-5 order-lg-1">
							<div className="pb-lg-5 mb-lg-5 text-center text-lg-left text-lg-nowrap">
								{ pretitleComp }
								{ titleComp }
								{ subtitleComp }
								{ buttonComp }
							</div>
						</div>
					</div>
				</div>
			</div>
		)
			
		return output
	} )

	const defaultCarouselOptions = applyFilters( 'cartzillagb.hero-carousel-1.main-block.classes', {
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows : true,
		adaptiveHeight : true,
		prevArrow: '<i class="czi-arrow-left"></i>',
		nextArrow: '<i class="czi-arrow-right"></i>',
		pauseOnHover: true,
		autoplay: autoplay,
		responsive: [
			{
				breakpoint: 0,
				settings: {
					nav: true,
					controls: false
				}
			},
			{
				breakpoint: 992,
				settings: {
					nav: false,
					controls: true
				}
			},
		],
	}, props )

	let carouselOptions = {
		dots: false,
		fade: true,
		mode: "gallery",
		speed: 1000,
	}

	carouselOptions = { ...defaultCarouselOptions, ...carouselOptions }

	const wraperAttr = {}

	wraperAttr.className = classnames( [
		'cz-carousel',
		'cz-controls-lg',
	] )

	return (
		<div id={ blockId } className={ mainClasses }>
			<div { ...wraperAttr }>
				<div className="js-slick-carousel" data-slick={ JSON.stringify( carouselOptions ) }>
					{ content }
				</div>
			</div>
		</div>
	)
}

export default compose(
)( save )
